import React from 'react';
import { makeStyles } from '../../../../theme';
import Box, { HORIZONTAL } from '../../../layout/box';

const styles = ({ numOfDots, color }) => makeStyles(
    ({ palette, spacing }) => ({
        linearRhombusProgressContainer: {
            width: spacing(numOfDots * 3),
            justifyContent: 'space-between',
            ...Array(numOfDots).fill(0).reduce((acc, _, indx) => {
                acc[`& div:nth-child(${numOfDots - indx})`] = {
                    animationDelay: indx === 0 ? '0s' : `-0.${12 * indx}s`
                };
                return acc;
            }, {})
        },
        '@keyframes anim': {
            '0%': { transform: 'rotate(45deg) scale(0.7)' },
            '50%': { transform: 'rotate(45deg)  scale(1.5)' },
            '100%': { transform: 'rotate(45deg)  scale(0.7)' }
        },
        dot: {
            width: spacing(0.7),
            height: spacing(0.7),
            backgroundColor: palette[color].main,
            animation: '$anim 1s infinite linear'
        }
    })
);

const LinearRhombusProgress = React.memo(
    ({ id, numOfDots = 3, color = "primary", ...props }) => {
        const classes = styles({ numOfDots, color })();

        const dots = [];
        for(let i = 0; i < numOfDots; i++) {
            dots.push(
                <Box key={`lin-rhom-prog-dot-${i}`} className={classes.dot} />
            );
        }

        return (
            <Box id={id} type={HORIZONTAL} className={classes.linearRhombusProgressContainer}>
                {dots}
            </Box>
        )
    }
);

export default LinearRhombusProgress;